module.exports = __webpack_public_path__ + "img/hs_nagoya.eaf61e5f.png";